

export enum PaymentMethod {
  COD = 'cod', // Cash on Delivery
  CREDIT_CARD = 'credit-card',
  PAYPAL = 'paypal',
  BANK_TRANSFER = 'bank-transfer'
}
